<template>
<div>
    <invoice-form :invoiceFormPropsFunctions="invoiceFormPropsFunctions" :getClientInvoiceList="getClientInvoiceList" ref="invoiceFormModal"></invoice-form>
    <div class="custom-search">
        <b-row>
            <b-col class="col-md-2">
                <label for="invoice-debit-no-input">{{ $t('clientInvoices.debit_no') }}</label>
                <b-form-input size="sm" v-model="debitNo" v-on:keyup.enter="getClientInvoiceList()" :placeholder="$t('clientInvoices.debit_no')" type="text" class="d-inline-block" />
            </b-col>
            <b-col class="col-md-2">
                <label for="invoice-reference-no-input">{{ $t('clientInvoices.ref_no') }}</label>
                <b-form-input size="sm" v-model="recordNo" v-on:keyup.enter="getClientInvoiceList()" :placeholder="$t('clientInvoices.ref_no')" type="text" class="d-inline-block" />
            </b-col>
            <b-col class="col-md-2">
                <b-form>
                    <label for="invoice-employee-input">{{ $t('clientInvoices.employee') }}</label>
                    <b-form-select id="invoice-employee-input" :placeholder="$t('clientInvoices.employee')" size="sm" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
                </b-form>
            </b-col>
            <b-col class="col-2">
                <b-form-group>
                    <label for="invoice-payment-status-input">{{ $t('clientInvoices.payment_status') }}</label>
                    <div class="d-flex align-items-center">
                        <b-form-select id="invoice-payment-status-input" @change="getClientInvoiceList()" :placeholder="$t('clientInvoices.payment_status')" size="sm" v-model="invoicePaymentStatusSelect" value-field="id" text-field="name" :options="invoicePaymentStatusOption" />
                    </div>
                </b-form-group>
            </b-col>
            <b-col class="col-2">
                <b-form-group>
                    <label for="invoice-status-input">{{ $t('clientInvoices.status') }}</label>
                    <div class="d-flex align-items-center">
                        <b-form-select id="invoice-status-input" @change="getClientInvoiceList()" :placeholder="$t('clientInvoices.status')" size="sm" v-model="invoiceStatusSelect" value-field="id" text-field="name" :options="invoiceStatusOption" />
                    </div>
                </b-form-group>
            </b-col>
            <b-col class="col-md-2 custom-search d-flex justify-content-end mt-2">
                <div class="d-flex align-items-center">
                    <b-button style="float:right;" class="mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getClientInvoiceList()" @click="getClientInvoiceList()">{{ $t('clientInvoices.list') }}</b-button>
                    <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                </div>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table id="clientInvoiceTable" ref="clientInvoiceTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" :pagination-options="{
            enabled: true,
            perPage: pageLength
          }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'debitNo'" class="text-nowrap">
                {{ $t('clientInvoices.debit_no') }}
            </span>
            <span v-else-if="props.column.field === 'clientAccountingNumber'" class="text-nowrap">
                {{ $t('clientInvoices.agent_name_accounting_no') }}
            </span>
            <span v-else-if="props.column.field === 'total'" class="text-nowrap">
                {{ $t('clientInvoices.amount') }}
            </span>
            <span v-else-if="props.column.field === 'currencyCode'" class="text-nowrap">
                {{ $t('clientInvoices.currency_code') }}
            </span>
            <span v-else-if="props.column.field === 'invoiceStatus'" class="text-nowrap">
                {{ $t('clientInvoices.status') }}
            </span>
            <span v-else-if="props.column.field === 'isPaid'">
                {{ $t('clientInvoices.is_paid') }}
            </span>
            <span v-else-if="props.column.field === 'employee'" class="text-nowrap">
                {{ $t('clientInvoices.employee') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'date'">
                <span style="font-size: smaller;">
                    {{$formatFn(props.row.date) }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'total'">
                <span style="font-size: smaller;">
                    {{$formatMoney(props.row.total) }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'isPaid'">
                <span>
                    <b-form-checkbox disabled v-model="props.row.isPaid" />
                </span>
            </span>
            <span v-else-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                    <!-- STOCK 1420 
                        <span v-if="props.row.InvoiceStatusId == 1">
                            <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                                <feather-icon icon="XIcon" />
                            </b-button>
                        </span>-->
                    <!-- End Of Code : If InvoiceStatusId changes in table code need to be changed too.  -->
                </span>
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','50']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getClientInvoiceList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        clientId: {
            type: Number
        }
    },
    data() {
        return {
            total: 0,
            pageLength: 10,
            invoiceFormPropsFunctions: 4,
            dir: false,
            pageNo: 1,
            columns: [{
                    label: this.$t('clientInvoices.debit_no'),
                    field: `debitNo`,
                },
                {
                    label: this.$t('clientInvoices.proforma_date'),
                    field: `proformaDate`,
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('clientInvoices.record_no'),
                    field: `recordNo`,
                },
                {
                    label: this.$t('clientInvoices.amount'),
                    field: `total`,
                },
                {
                    label: this.$t('clientInvoices.currency_code'),
                    field: `currencyCode`,
                },
                {
                    label: this.$t('clientInvoices.status'),
                    field: `invoiceStatus`,
                },
                {
                    label: this.$t('clientInvoices.agent_name_accounting_no'),
                    field: `clientAccountingNumber`,
                },
                {
                    label: this.$t('clientInvoices.is_paid'),
                    field: `isPaid`,
                },
                {
                    label: this.$t('clientInvoices.employee'),
                    field: `employee`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '6em'
                },
            ],
            rows: [],
            searchTerm: '',
            debitNo: '',
            invoiceClient: '',
            employeeSelect: 0,
            employeeOption: [],
            invoiceClientAccountingNo: '',
            statusSelect: 0,
            invoiceStatusOption: [],
            paid: true,
            notPaid: false,
            count: '',
            invoicePaymentStatusSelect: 0,
            invoicePaymentStatusOption: [],
            recordNo: '',
            invoiceStatusOption: [],
            invoiceStatusSelect: 0,
        }
    },
    mounted() {
        this.getClientInvoiceList()
    },
    methods: {
        async deleted(data) {
            this.count = data.InvoiceDetailCount
            data = {
                id: data.id
            }
            const controller = {
                name: 'Invoice'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteInvoiceConfirm(this.count).then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getClientInvoiceList()
                        } else {
                            if (response.data.resultMessage == 'ThereIsAInvoiceDetailInThisRecord') {
                                this.$InvoiceDetailError()
                            } else {
                                this.$CustomWarningAlert(response.data.resultMessage)
                            }
                            this.getClientInvoiceList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.invoiceFormModal.showInfo(id)
        },
        getClientInvoiceList() {
            this.rows = []
            const controller = {
                name: 'Invoice',
                actionName: 'GetClientInvoicesList'
            }
            const data = {
                clientId: this.clientId,
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                debitNo: this.debitNo,
                invoiceTypeId: 0,
                employeeId: this.employeeSelect,
                invoiceStatusId: this.invoiceStatusSelect,
                invoicePaymentStatus: this.invoicePaymentStatusSelect,
                recordNo: this.recordNo
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.total = response.data.total
                    this.employeeOption = response.data.employeeList
                    this.invoiceStatusOption = response.data.invoiceStatusList
                    this.invoicePaymentStatusOption = response.data.paymentStatusList
                    response.data.clientInvoicesList.forEach(element => {
                        this.rows.push(element)
                    })
                    this.invoiceStatusOption.splice(0, 0, this.$nullSelected()),
                        this.employeeOption.splice(0, 0, this.$nullSelected())
                    this.invoicePaymentStatusOption.splice(0, 0, this.$nullSelected())

                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportExcel() {
            const controller = {
                name: 'Invoice',
                actionName: 'CreateClientInvoiceSpecialExcel'
            }
            const data = {
                clientId: this.clientId,
                debitNo: this.debitNo,
                invoiceTypeId: 0,
                employeeId: this.employeeSelect,
                invoiceStatusId: this.invoiceStatusSelect,
                invoicePaymentStatus: this.invoicePaymentStatusSelect,
                recordNo: this.recordNo
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Client Special Invoices", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
